import { render } from "./userRepos.vue?vue&type=template&id=bc556d94"
import script from "./userRepos.vue?vue&type=script&lang=js"
export * from "./userRepos.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__